
import { Alert, Card, Col, ConfigProvider, DatePicker, Divider, Form, List, Row, Select, Typography } from "antd";
import SDIModal from "../../../../components/ui/SDIModal";
import PropTypes from "prop-types";
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../../../variables/api/axiosInstance";
import BarreBottom from "../../../../components/docs/BarreBottom";
import dayjs from "dayjs";
import AvenantAgencySelector from "./AvenantAgencySelector";

const { Text, Title } = Typography;

const AugmentationDeGarantie = (props) => {
    const [modalAugmentationGarantie, setModalAugmentationGarantie] = useState(
        props.open
    );

    const [loading, setLoading] = useState(false);
    const [garanties, setGaranties] = useState([[]]);
    const [compulsoryGuaranties, setCompulsoryGuaranties] = useState([]);
    const [currentPreview, setCurrentPreview] = useState("");
    const [preview, setPreview] = useState("");
    const [dateEffetAvenant, setDateEffetAvenant] = useState(() =>
        props?.contrat?.dateEffet ? dayjs(props?.contrat?.dateEffet) : dayjs()
    );

    useEffect(() => {
        if (props?.contrat?.codeId) {
            axiosInstance
                .get(
                    `/api/contrat/preview/${props?.contrat?.codeId}`
                )
                .then((response) => {
                    // console.log("AG Preview: ", response.data);
                    setCurrentPreview(response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [props?.contrat?.codeId]);

    const { CheckCircleOutlined, PlusCircleOutlined, SafetyCertificateOutlined } = require('@ant-design/icons');

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XAF' }).format(value);
    };

    useEffect(() => {
        setModalAugmentationGarantie(props.open);
        if (props.open) {
            setDateEffetAvenant(props?.contrat?.dateEffet ? dayjs(props?.contrat?.dateEffet) : dayjs());
            axiosInstance
                .get(
                    `/api/garantie/non-compulsory/engins/${props?.contrat?.codeId}`)
                .then((response) => {
                    // console.log(response.data);
                    setCompulsoryGuaranties(response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [props.open, props?.contrat?.dateEffet]);

    const navigate = useNavigate();

    const handleSousGarantie = (index, value) => {
        var gtys = [];
        if (value.length === 1) {
            gtys.push(JSON.parse(value));
        } else {
            value.forEach((element) => {
                try {
                    gtys.push(JSON.parse(element));
                } catch (err) {
                    gtys.push(element);
                }
            });
        }
        let compulsoryGuarantiesCopy = [...compulsoryGuaranties];
        compulsoryGuarantiesCopy?.forEach((e, i) => {
            if (i === index) {
                e.sousGaranties = gtys;
            }
        });

        setCompulsoryGuaranties(compulsoryGuarantiesCopy);
        triggerPreview(compulsoryGuarantiesCopy, dateEffetAvenant);
    };

    const triggerPreview = (payloadSource, selectedDate) => {
        const formattedDate = selectedDate ? selectedDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
        const payload = Array.isArray(payloadSource)
            ? payloadSource.map((engin) => ({
                ...engin,
                dateEffetAvenant: formattedDate,
            }))
            : [];

        axiosInstance
            .put(
                `/api/engin/preview-augmentation-garantie/${props?.contrat?.codeId}${formattedDate ? `?dateEffet=${formattedDate}` : ""}`,
                payload
            )
            .then((ress) => {
                // console.log("PREVIEW: ", ress.data);
                setPreview(ress.data);
            })
            .catch((errr) => {
                console.log(errr);
            });
    };

    const handleDateEffetChange = (date) => {
        setDateEffetAvenant(date);
        if (compulsoryGuaranties?.length) {
            triggerPreview(compulsoryGuaranties, date);
        }
    };


    const handleGarantiesChange = (index, e) => {
        let newGaranties = [...garanties];
        newGaranties[index] = e;
        setGaranties(newGaranties);
        handleSousGarantie(index, e);
    };

    const enterLoading = () => {
        setLoading(true);
    };

    const outLoading = () => {
        setLoading(false);
    };

    const handleAugmentationSubmit = () => {
        enterLoading();
        console.log("All: ", preview);
        if (preview?.engins?.length > 0) {
            const formattedDate = dateEffetAvenant ? dateEffetAvenant.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
            const payload = {
                ...preview,
                dateEffetAvenant: formattedDate,
                ...(formattedDate ? { dateEffet: formattedDate } : {})
            };
            axiosInstance
                .put(
                    `/api/engin/augmentation-garantie`,
                    JSON.stringify(payload))
                .then((resEngin) => {
                    toast("Augmentation de garanties effectuée!");
                    outLoading();
                    setModalAugmentationGarantie(false);
                    props.update(false);
                    navigate(`/details-contrat/${resEngin.data.codeId}`, { replace: true });
                    window.location.reload();
                })
                .catch((errEngin) => {
                    console.log(errEngin);
                    toast("Erreur lors de l'augmentation des garanties");
                });

        } else {
            toast("Aucune garantie ajoutée");
            outLoading();
            setModalAugmentationGarantie(false);
            props.update(false);
        }
    };

    const handleCancel = () => {
        setModalAugmentationGarantie(false);
        props.update(false);
    };

    return (
        <SDIModal
            title="AUGMENTATION DE GARANTIES"
            centered
            confirmLoading={loading}
            open={modalAugmentationGarantie}
            onOk={() => handleAugmentationSubmit()}
            onCancel={() => handleCancel()}
            width={900}
            zIndex={1940}
        >
            <ConfigProvider locale={frFR}>
                <div className="augmentation-garanties-content">
                    <AvenantAgencySelector
                        organismeCode={props?.contrat?.organisme?.code}
                        defaultAgence={props?.contrat?.producteur?.agence || props?.contrat?.intermediaire?.agence}
                    />
                    <Card className="mb-3" size="small" title="Paramètres de l'avenant">
                        <Form layout="vertical">
                            <Form.Item label="Date d'effet de l'avenant" required>
                                <DatePicker
                                    value={dateEffetAvenant}
                                    onChange={handleDateEffetChange}
                                    format="DD/MM/YYYY"
                                    allowClear={false}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Form>
                    </Card>

                    {currentPreview?.engins?.map((item, index) => (
                        <div key={item.codeId} className="engin-section">
                            {/* Section Récapitulatif de l'engin */}
                            <Card className="mb-4" size="small" style={{ backgroundColor: "#14356a" }} >
                                <div className="engin-recap">
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="info-item" >
                                                <Text style={{ color: "white" }} strong>Immatriculation:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.immatriculation}</Text>
                                            </div>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>Marque:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.marque}</Text>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>N° Chassis:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.numeroChassis}</Text>
                                            </div>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>Type:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.type || 'N/A'}</Text>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>

                            {/* Section Garanties actuelles */}
                            <Card className="mb-4" size="small" title="Garanties actuellement souscrites">
                                <Row gutter={16}>
                                    {/* Garanties obligatoires */}
                                    <Col span={12}>
                                        <div className="garanties-section">
                                            <Title level={5} className="section-title">
                                                <SafetyCertificateOutlined className="mr-2" />
                                                Garanties Obligatoires
                                            </Title>
                                            <List
                                                size="small"
                                                dataSource={item?.compulsoryGuaranties?.filter((garantie) => garantie.obligatoire && garantie.primeNette) || []}
                                                renderItem={(garantie) => (
                                                    <List.Item>
                                                        <div className="garantie-item">
                                                            <CheckCircleOutlined className="text-green-500 mr-2" />
                                                            <div>
                                                                <Text strong>{garantie.nom}</Text>
                                                                <div className="garantie-details">
                                                                    <Text type="secondary">
                                                                        Capital: {formatCurrency(garantie.capital)}
                                                                    </Text>
                                                                    <Text type="secondary" className="ml-3">
                                                                        Prime: {formatCurrency(garantie.primeNette)}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </Col>

                                    {/* Garanties optionnelles */}
                                    <Col span={12}>
                                        <div className="garanties-section">
                                            <Title level={5} className="section-title">
                                                <PlusCircleOutlined className="mr-2" />
                                                Garanties Optionnelles
                                            </Title>
                                            <List
                                                size="small"
                                                dataSource={item?.compulsoryGuaranties?.filter((garantie) => !garantie.obligatoire) || []}
                                                renderItem={(garantie) => (
                                                    <List.Item>
                                                        <div className="garantie-item">
                                                            <CheckCircleOutlined className="text-blue-500 mr-2" />
                                                            <div>
                                                                <Text strong>{garantie.nom}</Text>
                                                                <div className="garantie-details">
                                                                    <Text type="secondary">
                                                                        Capital: {formatCurrency(garantie.capital)}
                                                                    </Text>
                                                                    <Text type="secondary" className="ml-3">
                                                                        Prime: {formatCurrency(garantie.primeNette)}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            {/* Section Ajout de nouvelles garanties */}
                            <Card className="mb-4" size="small" title="Ajouter de nouvelles garanties">
                                {compulsoryGuaranties?.filter(e => e.codeId === item.codeId).length && compulsoryGuaranties?.find(e => e.codeId === item.codeId)?.compulsoryGuaranties?.length ? (
                                    <div>
                                        <Form layout="vertical">
                                            <Form.Item label="Sélectionner les garanties à ajouter">
                                                <Select
                                                    mode="multiple"
                                                    placeholder="Choisir les garanties..."
                                                    onChange={(event) => {
                                                        handleGarantiesChange(index, event);
                                                        handleSousGarantie(index, event);
                                                    }}
                                                    options={compulsoryGuaranties?.find(e => e.codeId === item.codeId)?.compulsoryGuaranties.map((guaranty, idx) => ({
                                                        label: (
                                                            <div className="garantie-option">
                                                                <div className="garantie-name">{guaranty.nom}</div>
                                                                <div className="garantie-price">
                                                                    <Text type="secondary">
                                                                        Prime Annuelle: {formatCurrency(guaranty.primeNette)} |
                                                                        Capital: {formatCurrency(guaranty.capital)}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        ),
                                                        value: JSON.stringify(guaranty),
                                                        key: idx
                                                    }))}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </div>
                                ) : (
                                    <Alert
                                        message="Aucune garantie supplémentaire disponible"
                                        description="Toutes les garanties optionnelles sont déjà ajoutées à cet engin"
                                        type="warning"
                                        showIcon
                                    />
                                )}

                            </Card>

                            {/* Séparateur entre engins si plusieurs */}
                            {index < compulsoryGuaranties.length - 1 && <BarreBottom />}
                        </div>
                    ))}

                    {/* Récapitulatif des coûts */}
                    {garanties?.length > 0 && (
                        <Card className="cost-summary mt-3" size="small">
                            <Title level={5}>Récapitulatif des coûts</Title>
                            <div className="cost-breakdown">
                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Date d'effet de l'avenant :</Text>
                                    </Col>
                                    <Col>
                                        <Text strong>{dateEffetAvenant ? dateEffetAvenant.format('DD/MM/YYYY') : '-'}</Text>
                                    </Col>
                                </Row>

                                <Divider className="my-2" />

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Prime nette au prorata:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong>{formatCurrency(preview?.primeNette || 0)}</Text>
                                    </Col>
                                </Row>

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Accessoires:</Text>
                                    </Col>
                                    <Col>
                                        <Text>{formatCurrency(preview?.accessoires || 0)}</Text>
                                    </Col>
                                </Row>

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Taxes(6%) :</Text>
                                    </Col>
                                    <Col>
                                        <Text>{formatCurrency(preview?.taxes || 0)}</Text>
                                    </Col>
                                </Row>

                                <Divider className="my-2" />

                                <Row justify="space-between" className="cost-line total-cost">
                                    <Col>
                                        <Text strong className="text-lg">TOTAL À PAYER:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong className="text-lg text-blue-600">
                                            {formatCurrency(preview?.primeTotale || 0)}
                                        </Text>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    )}
                </div>
            </ConfigProvider>

            <style jsx>
                {`
                    .augmentation-garanties-content {
                        max-height: 70vh;
                        overflow-y: auto;
                    }
                    
                    .engin-section {
                        margin-bottom: 20px;
                    }
                    
                    .engin-recap .info-item {
                        margin-bottom: 8px;
                    }
                    
                    .garanties-section {
                        height: 100%;
                    }
                    
                    .section-title {
                        margin-bottom: 16px !important;
                        color: #1890ff;
                    }
                    
                    .garantie-item {
                        display: flex;
                        align-items: flex-start;
                        width: 100%;
                    }
                    
                    .garantie-details {
                        font-size: 12px;
                        margin-top: 4px;
                    }
                    
                    .garantie-option {
                        padding: 4px 0;
                    }
        
                    .garantie-name {
                        font-weight: 500;
                    }
                    
                    .garantie-price {
                        font-size: 12px;
                        margin-top: 2px;
                    }
                    
                    .cost-summary {
                        background-color: #f8f9fa;
                        border: 1px solid #e9ecef;
                    }
                    
                    .cost-breakdown .cost-line {
                        margin-bottom: 8px;
                    }
                    
                    .cost-breakdown .total-cost {
                        background-color: #e6f7ff;
                        padding: 8px;
                        border-radius: 4px;
                        margin-top: 8px;
                    }
                    
                    .ml-2 { margin-left: 8px; }
                    .ml-3 { margin-left: 12px; }
                    .mr-2 { margin-right: 8px; }
                    .mt-3 { margin-top: 12px; }
                    .mb-4 { margin-bottom: 16px; }
                    .my-2 { margin: 8px 0; }
                    .text-lg { font-size: 16px; }
                    .text-blue-600 { color: #1890ff; }
                    .text-green-500 { color: #52c41a; }
                    .text-blue-500 { color: #1890ff; }
                `}
            </style>
        </SDIModal>
    );
};

AugmentationDeGarantie.propTypes = {
    open: PropTypes.bool,
    update: PropTypes.func,
    contrat: PropTypes.object
};

export default AugmentationDeGarantie;
